// Configuración para react-pdf
// import { Font } from '@react-pdf/renderer';

// Registrar fuentes para react-pdf
// Font.register({
//   family: 'Roboto',
//   fonts: [
//     { src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf' },
//     { src: 'https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf', fontWeight: 'bold' }
//   ]
// });

// Función para inicializar la configuración de PDF
export const initPDFConfig = () => {
  // Configuración para evitar el error de BindingError
  if (typeof window !== 'undefined') {
    // Asegurarse de que la configuración se aplique solo en el navegador
    window.PDFJS = { 
      ...window.PDFJS, 
      disableWorker: true,
      disableStream: true,
      disableAutoFetch: true
    };
  }
};

// Exportar configuración predeterminada
export default {
  initPDFConfig
};